import get from 'lodash/get'

export const getAddresses = (state) => get(state, ['vegetation', 'address', 'addresses']);
export const isLoadingAddresses = (state) => get(state, ['vegetation', 'address', 'loading']);
export const getAddressQuery = (state) => get(state, ['vegetation', 'address', 'query']);

export const getSelectedAddress = (state) => get(state, ['vegetation', 'address', 'selected']);




// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/address.js